/**
 * The mode "Try again" returns to: the ended attempt's own (Written Chat,
 * Live Conversation or Video). Try again itself creates nothing (CoachingPage
 * handleRetry): the retry is created by the FIRST commitment in that view, the
 * first Send or Start, through POST /coaching/sessions/:id/retry with the
 * chosen modality, so an abandoned Try again leaves no unused session.
 */
import type { ConversationModality } from '../store/api/coachingApi';

export type RetryInputMode = 'text' | 'live' | 'video';

export function retryInputMode(modality: ConversationModality | null): RetryInputMode {
  if (modality === 'realtime_audio') return 'live';
  if (modality === 'realtime_audio_video') return 'video';
  return 'text';
}
